export default __webpack_public_path__ + "static/media/0h.e3047e10.jpg";